import styled from 'astroturf/react'
import { UserSingleIcon } from '@calendly/ui/components/icons'
const textColorLevel2 = 'var(--text-color-level2, rgba(26, 26, 26, 0.61))'
import { DetailsItem as Item } from '@calendly/booking-kit'
import _PublisherName from "publisher-PublisherName.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/confirmation/pages/new_confirmation/details/publisher.js?styleId=PublisherName";


const PublisherName = /*#__PURE__*/styled('span', null, {
  displayName: "PublisherName",
  styles: _PublisherName
})

export default ({ name }) => (
  <Item>
    <UserSingleIcon size="large" spacingRight={8} data-id="details-item-icon" />
    <PublisherName>{name}</PublisherName>
  </Item>
)
